import { Link } from "react-router-dom";
import "./Footer.css";
import { useEffect, useState } from "react";
const Footer = () => {
  const date = new Date(Date.now());
  let year = date.getFullYear();
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");


  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");

    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <>
      <main>
        <footer>
          <div className="gap top-spac60 drk-bg remove-bottom">
            <div className="container">
              <div className="footer-data">
                <div className="row">
                  <div className="col-md-4 col-sm-12 col-lg-4">
                    <div className="wdgt-box">
                      <div className="logo">
                        <a title="Logo">
                          <img
                            id="logo"
                            src={require("../../Assets/images/trasparent-logo.png")}
                            alt="logo2.png"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-8 col-sm-12 col-lg-8">
                    <div className="row">
                      <div className="col-md-4 col-sm-4 col-lg-4">
                        <div className="wdgt-box">
                          <h4>
                            {rtl
                              ? "روابط سريعة"
                              : fr
                              ? "Liens Rapides"
                              : "Quick Links"}
                          </h4>
                          <ul>
                            <li>
                              <Link to="/about-us">
                                <a>
                                  {rtl
                                    ? "من نحن"
                                    : fr
                                    ? "A propos de nous"
                                    : "About Us"}
                                </a>
                              </Link>
                            </li>
                            <li>
                              <Link to="/our-companies">
                                <a>
                                  {rtl
                                    ? "شركاتنا"
                                    : fr
                                    ? "Nos entreprises"
                                    : "Our Companies"}
                                </a>
                              </Link>
                            </li>
                            <li>
                              <Link to="/services">
                                <a>
                                  {rtl
                                    ? "خدماتنا"
                                    : fr
                                    ? "Nos services"
                                    : "Our Services"}
                                </a>
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-4 col-lg-4">
                        <div className="wdgt-box">
                          <h4>
                            {rtl
                              ? "روابط مفيدة"
                              : fr
                              ? "Liens Utiles"
                              : "Useful Links"}
                          </h4>
                          <ul>
                            <li>
                              <Link to="/gateway-africa-asia">
                                <a>
                                  {rtl
                                    ? "بوابة"
                                    : fr
                                    ? "La Porte d'entrée"
                                    : "Gateway"}
                                </a>
                              </Link>
                            </li>
                            <li>
                              <Link to="/careers">
                                <a>
                                  {rtl ? "وظائف" : fr ? "Carrières" : "Careers"}
                                </a>
                              </Link>
                            </li>
                            <li>
                              <Link to="/commodity-desk">
                                <a>
                                  {rtl
                                    ? "مكتب السلع"
                                    : fr
                                    ? "Bureau des matières premières"
                                    : "Commodity Desk"}
                                </a>
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-4 col-lg-4">
                        <div className="wdgt-box">
                          <h4>
                            {rtl
                              ? " اتصل بنا "
                              : fr
                              ? "Contactez nous"
                              : "Contact Us"}
                          </h4>
                          <ul id="location" className="cont-lst">
                            <li>
                              <i className="flaticon-location-pin"></i>
                              {rtl
                                ? `71-75 شارع شيلتون
كوفنت جاردن, لندن, المملكة المتحدة WC2H 9JQ
`
                                : fr
                                ? "Acceuil"
                                : `71-75 Shelton
                                                            Street, Covent
                                                            Garden, London, WC2H
                                                            9JQ`}
                            </li>
                            <li>
                              <i className="flaticon-call"></i>
                              +44 (020) 8099-8978
                            </li>
                            <li>
                              <i className="flaticon-email"></i>
                              <a>info@makkahalmadinah.com</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bottom-bar">
                <p>
                  {rtl
                    ? `© حقوق الطبع والنشر ${year}  جميع الحقوق محفوظة .`
                    : fr
                    ? `© Copyright ${year}. Tous droits réservés.`
                    : `© Copyright ${year}. All Rights Reserved.`}
                </p>
                <div className="scl">
                  <a href="#" id="fb" title="Facebook" target="_blank">
                    <img
                      src={require("../../Assets/images/facebook-footer-icon.PNG")}
                    />
                  </a>
                  <a href="#" title="Instagram" target="_blank">
                    <img
                      src={require("../../Assets/images/instagram-footer-icon.PNG")}
                    />
                  </a>
                  <a href="#" title="Twitter" target="_blank">
                    <img
                      src={require("../../Assets/images/twitter-footer-icon.png")}
                    />
                  </a>
                  <a href="#" title="Linkedin" target="_blank">
                    <img
                      src={require("../../Assets/images/linkedin-footer-icon.PNG")}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </main>
    </>
  );
};

export default Footer;
